import { StackScreenProps } from "@react-navigation/stack";
import React, { useState } from "react";
import { Linking, Platform } from "react-native";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useOrderById, useRepeatOrder } from "@/hooks/domain/order";
import { RootNavigation } from "@/navigation/Root";
import { OrderStackParamList } from "@/navigation/stacks/OrderStack";

import OrderDetailsModal from "../components/OrderDetailsModal";
import OrderTrackingMobile from "./OrderTracking.mobile";
import OrderTrackingWeb from "./OrderTracking.web";

type ScreenProps = StackScreenProps<OrderStackParamList, "orderTracking">;

const OrderTracking = ({ route }: ScreenProps) => {
  const orderId = route?.params?.orderId;

  const { isWebMode } = useViewport();
  const { goBack, navigate } = useAppNavigation<RootNavigation>();

  const { data: order, isLoading } = useOrderById(orderId, {
    enabled: !!orderId,
    onError: () => {
      if (!orderId) {
        goBack();
      }
    },
  });

  const { repeatOrder } = useRepeatOrder();

  const hasEvaluation =
    !!order?.avaliacao &&
    !!order?.avaliacao?.avaliacao_app &&
    !!order?.avaliacao?.avaliacao_entrega &&
    !!order?.avaliacao?.avalicao_servico;

  const [modalVisible, setModalVsible] = useState(false);

  const onPressStorePhone = () => {
    const store = order?.estabelecimento;
    const phone = store?.telefone?.replace(" ", "");
    if (Platform.OS === "ios") {
      Linking.openURL(`telprompt:${phone}`);
    } else {
      Linking.openURL(`tel:${phone}`);
    }
  };

  const openOrderRating = () => {
    navigate("orderStack", {
      screen: "orderEvaluation",
      params: { orderId: order._id },
    });
  };

  const onPressHelpCentral = () => {
    navigate("settingsStack", {
      screen: "helpCentral",
      initial: false,
    });
  };

  const Screen = isWebMode ? OrderTrackingWeb : OrderTrackingMobile;

  return (
    <>
      <Screen
        order={order}
        hasEvaluation={hasEvaluation}
        isLoading={isLoading}
        onGoBack={goBack}
        openOrderDetails={() => setModalVsible(true)}
        openOrderRating={openOrderRating}
        onPressStorePhone={onPressStorePhone}
        onPressHelpCentral={onPressHelpCentral}
      />
      {order && (
        <OrderDetailsModal
          isOpen={modalVisible}
          order={order}
          onClose={() => setModalVsible(false)}
          onPressRepeatOrder={() => {
            repeatOrder(order);
            setModalVsible(false);
          }}
        />
      )}
    </>
  );
};

export default OrderTracking;
